import React, { useEffect } from "react";
import { connect } from "react-redux";
import { submitInquiry } from "./FloatingSlice";
import FloatingActions from "../../components/FloatingActions";

const FloatingContainer = ({ 
  whatsappNumber,
  whatsappEnabled,
  inquiryEnabled,
  inquiryAction,
  captchaSrc,
  status,
  submitting,
  submitSuccess,
  submitError,

  submitInquiry
}) => {
  useEffect(() => {
    if (status === "idle") {
      // loadFloating();
    }
  }, [ status]);

  // Create a wrapper function to handle inquiry submission
  const handleSubmitInquiry = (inquiryData) => {
    return submitInquiry(inquiryData);
  };

  return (
    <FloatingActions
      whatsappNumber={whatsappNumber}
      whatsappEnabled={whatsappEnabled}
      inquiryEnabled={inquiryEnabled}
      inquiryAction={inquiryAction}
      captchaSrc={captchaSrc}
      status={status}
      submitInquiry={handleSubmitInquiry}
      submitting={submitting}
      submitSuccess={submitSuccess}
      submitError={submitError}
    />
  );
};

const mapStateToProps = (state) => ({
  whatsappNumber: state.floating.whatsappNumber,
  whatsappEnabled: state.floating.whatsappEnabled,
  inquiryEnabled: state.floating.inquiryEnabled,
  inquiryAction: state.floating.inquiryAction,
  captchaSrc: state.floating.captchaSrc,
  status: state.floating.status,
  submitting: state.floating.submitting,
  submitSuccess: state.floating.submitSuccess,
  submitError: state.floating.submitError,
});

const mapDispatchToProps = {
  submitInquiry,
};

export default connect(mapStateToProps, mapDispatchToProps)(FloatingContainer);
